'use client';

import type { ReactElement, ReactNode } from 'react';
import { Toaster } from '../ui/sonner';
import { useWindowSize } from '@/lib/hooks/use-window-size';

export default function ToasterProvider({
  children,
}: Readonly<{ readonly children: ReactNode }>): ReactElement {
  const { size } = useWindowSize();
  return (
    <>
      {children}
      <Toaster position={size.width && size.width > 640 ? 'bottom-right' : 'top-center'} />
    </>
  );
}
